import ToolsStyleWrapper from '../../../src/components/content-ai-tools/components/ToolsStyleWrapper';
import { ClusterKeywords } from '../../../src/components/content-ai-tools/ClusterKeywords';

const PublicDiscoveryKeywordsWrapped = () => {
  return <ToolsStyleWrapper component={ClusterKeywords} />;
};

export default PublicDiscoveryKeywordsWrapped;
